import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const NatureActionsService = {
    apply: async (payload) => axios.post(API_URL + "/nature_actions/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default NatureActionsService;